<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-if="product.id !== undefined"
          label="ID"
          v-model="product.id"
          disabled
        >
        </v-text-field>

        <v-text-field label="Code" v-model="product.code"></v-text-field>

        <v-text-field
          label="Name"
          v-model="product.name"
          :rules="requiredRule"
          required
        >
        </v-text-field>

        <v-text-field
          label="Unitati"
          v-model="product.units"
          :rules="requiredRule"
          required
        >
        </v-text-field>

        <v-text-field
          label="Pret achizitie"
          v-model="product.buyPrice"
          :rules="requiredNumberRules"
          required
        >
        </v-text-field>

        <v-text-field
          label="Pret vanzare"
          v-model="product.sellPrice"
          :rules="sellPriceRules"
          required
        >
        </v-text-field>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['product', 'onSubmit'],
  data() {
    return {
      valid: true,
      requiredRule: [
        (element) => {
          if (element.trim() === '') return 'Campul trebuie completata.';
          return true;
        },
      ],
      requiredNumberRules: [
        (element) => {
          // eslint-disable-next-line no-restricted-globals
          if (!element || isNaN(Number(element))) {
            return 'Campul trebuie completat';
          }
          return true;
        },
      ],

      sellPriceRules: [
        (v) => !!v || isNaN(Number(v)) || 'Campul trebuie completat.',
        (v) =>
          Number(this.product.buyPrice) < Number(v) ||
          'Pretul de vanzare este mai mic decat cel de achizitie',
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style>
</style>
